<template>
  <div>
    <v-popover
      placement="right"
      trigger="hover"
      :delay="{ show: 100, hide: 500 }"
    >
      <i class="pointer icon-fa icon-fa-bell"/>
      <template slot="popover">
        <div>
          <div v-for="r in records" class="card">
            <div class="card-header p-2">
              <strong>{{ r.type_id === 28 ? 'UTEKA' : '003' }}</strong>
            </div>
            <div class="card-body p-1">
              <p v-for="(c,i) in r.task_data.conditions" v-if="c.value"><span v-html="c.title"/>
                {{ !c.condition ? '=' : (c.condition === 'more' ? '>' : '<') }} {{ c.value }}</p>
            </div>
          </div>
        </div>
      </template>
    </v-popover>
  </div>
</template>
<script>
export default {
  props: ['records']
}
</script>
